<template>
  <div
    class="no-items main__light_green h5-headline text-start black--text "
    :class="customClass || ' py-16 px-12 mt-4 '"
    data-qa="empty-block">
    <span
      v-dompurify-html="text"
      data-qa="empty-block-text"/>
    <slot name="append"/>
  </div>
</template>

<script>
export default {
  name: 'emptyBlock',
  props: {
    text: String,
    customClass: String
  }
}
</script>
<style lang="scss" scoped>
.no-items {
  width: 100%;
  border-radius: 8px;
}
</style>
